import React from 'react';
import { withTranslation } from 'react-i18next';
import ReactModal from '../../../../components/Modal';

class CompetitiorsModal extends React.Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <ReactModal
                    modalState={this.props.isOpen}
                    className="width-sm"
                    onClose={this.props.onClose}
                >
                    <h2>{t('ai_tracking.projects.competitors.header')}</h2>
                    <div className="pages-modal-container">
                        {this.props.competitiors?.map((item) => {
                            return (
                                <div className="pages-modal-container-item" key={item.name}>
                                    {item.name} / {item.domain}
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            type="button"
                            className="button button-outline button-primary width-sm btn"
                            onClick={this.props.onClose}
                            style={{ lineHeight: 'unset' }}
                        >
                            {t('discover.entity_clusters.modal.close')}
                        </button>
                    </div>
                </ReactModal>
            </>
        );
    }
}

export default withTranslation()(CompetitiorsModal);
